import { render, staticRenderFns } from "./EditEtiquette.vue?vue&type=template&id=0e2294ea&"
import script from "./EditEtiquette.vue?vue&type=script&lang=js&"
export * from "./EditEtiquette.vue?vue&type=script&lang=js&"
import style0 from "./EditEtiquette.vue?vue&type=style&index=0&id=0e2294ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports